import { BootstrapError } from './BootstrapError';
import { InvalidPermissions } from '../invalid-permissions/InvalidPermisions';
import { Loading } from '../loading/Loading';
import TopNavBar from '../top-nav-bar/TopNavBar';
import { AppLayoutProps } from './AppLayout';

export function AppLayoutRenderHelper(props: AppLayoutProps) {
  if (props.status === 'success') {
    if (props.permissions && props.user) {
      return (
        <>
          <TopNavBar {...props} />
          {props.children}
        </>
      );
    } else if (!props.user || !props.permissions) {
      return (
        <>
          <TopNavBar {...props} />
          <InvalidPermissions />
        </>
      );
    } else {
      return <Loading showIcon />;
    }
  }

  // Bootstrap data/token could not be obtained after recovery attempts were
  // exhausted — show an actionable retry/re-auth state, never an indefinite
  // spinner. The header (user name + logout) stays visible.
  if (props.status === 'error') {
    return (
      <>
        <TopNavBar {...props} hideTabs />
        <BootstrapError onRetry={props.onRetry} />
      </>
    );
  }

  // Loading (and any other transient state). The header must NEVER be gated
  // by status, so it persists alongside the spinner — a transient mid-session
  // load never removes the user name / logout.
  return (
    <>
      <TopNavBar {...props} hideTabs />
      <Loading showIcon />
    </>
  );
}
